import * as React from 'react'
import * as LodashFP from 'lodash/fp'

export function useDidUpdate(cb: () => any, deps?: any[]) {
  const ranOnce = React.useRef(false)
  React.useEffect(() => {
    if (ranOnce.current) {
      cb()
    } else {
      ranOnce.current = true
    }
  }, deps) // eslint-disable-line react-hooks/exhaustive-deps
}

export function useDidMount(cb: () => any) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(cb, [])
}

function useDeepCompareMemoize(value: any) {
  const ref = React.useRef(undefined)

  if (!LodashFP.isEqual(value, ref.current)) {
    ref.current = value
  }

  return ref.current
}

export function useDeepCompareEffect(
  callback: () => void,
  dependencies: any[],
) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(callback, useDeepCompareMemoize(dependencies))
}

export function usePrevious<T>(value: T) {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  const ref = React.useRef<T>(value)

  // Store current value in ref
  React.useEffect(() => {
    ref.current = value
  }, [value]) // Only re-run if value changes

  // Return previous value (happens before update in useEffect above)
  return ref.current
}
